import React from 'react';

const LogoutIcon = ({ backgroundFill, fillColor, strokeColor, strokeWidth, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      fill={backgroundFill}
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      width={width}
    >
      <path d="M9.4,21.6h-4.6c-1.2,0-2.1-1-2.1-2.3V4.7c0-1.3,1-2.3,2.1-2.3h4.6" />
      <polyline points="7.8 12 21.4 12 15.6 17.9 21.4 12 15.5 6.1" />
    </svg>
  );
};

export default LogoutIcon;
